import { CellContext } from "@tanstack/react-table";
import { EntityIconList } from "@components/general/EntityIconList/EntityIconList";
import { WorkspaceDetailsRow } from "./NameCell";

export function EntitiesCell({
    row,
}: Readonly<CellContext<WorkspaceDetailsRow, any>>) {
    const entities = row.original.entities;
    if (!entities || entities.length === 0) {
        return null;
    }
    return (
        <EntityIconList
            entities={entities}
            maxEntitiesToDisplay={Number.MAX_VALUE}
            showLabel={false}
        />
    );
}
